export const getRelewiseCurrencyId = () => {
    const { RecordId: channelId, Currency: currency } = window.___initialData___?.requestContext.channel ?? {};

    if (!channelId || !currency) {
        return;
    }

    return `${channelId}_${currency}`;
};
